'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Wrapper = undefined;

var _templateObject = _taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 4px;\n\tposition: absolute;\n\twidth: ', ';\n\theight: ', ';\n\tbackground-color: ', ';\n\n\t&:after {\n\t\tcontent: ', ';\n\t\tposition: absolute;\n\t\tfont-size: 16px;\n\t\tcolor: rgba(0, 0, 0, 0.2);\n\t\ttop: 5px;\n\t\tright: 5px;\n\t\tfont-family: ', ';\n\t\tfont-weight: 700;\n\t}\n'], ['\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 4px;\n\tposition: absolute;\n\twidth: ', ';\n\theight: ', ';\n\tbackground-color: ', ';\n\n\t&:after {\n\t\tcontent: ', ';\n\t\tposition: absolute;\n\t\tfont-size: 16px;\n\t\tcolor: rgba(0, 0, 0, 0.2);\n\t\ttop: 5px;\n\t\tright: 5px;\n\t\tfont-family: ', ';\n\t\tfont-weight: 700;\n\t}\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _globals = require('../globals');

var _globals2 = _interopRequireDefault(_globals);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColor = _utils2.default.getColor;


var getVersion = function getVersion() {
	var packageJSON = require('../../package.json');

	return packageJSON.version;
};

var Wrapper = _styledComponents2.default.div(_templateObject, function (props) {
	return props.size;
}, function (props) {
	return props.size;
}, function (props) {
	return getColor(props, '#fff');
}, '"' + getVersion() + '"', _globals2.default.fonts.bold);

Wrapper.propTypes = {
	size: _propTypes2.default.string
};

Wrapper.defaultProps = {
	size: '98%'
};

exports.Wrapper = Wrapper;